export default __webpack_public_path__ + "static/media/gimp.7cff4c04.svg";